import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormGroup, InputGroup, Button, HTMLTable } from "@blueprintjs/core";
import { AxiosInstance } from 'axios';

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { License, HardwareId } from './Types'
import * as utils from "./utils";

interface CreateEmailProps {
    reg: AxiosInstance,
}

function CreateEmail({ reg }: CreateEmailProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue } = useForm<License>()
    const history = useHistory()
    const [isSending, setIsSending] = useState(false)

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const onSubmit = async (lcn: License) => {
        if (lcn.email && lcn.email.length > 0 && lcn.name && lcn.name.length > 0 && lcn.password && lcn.password.length > 0) {
            if (lcn.password == lcn.confirm) {
                onSave(lcn)
            } else {
                utils.showError(t('password_not_match'))
            }
        } else {
            utils.showError(t('insufficient_data'))
        }
    }

    const onSave = async (lcn: License) => {
        try {
            setIsSending(true)
            const res = await reg.post('/verifyadd', lcn)
            //console.log(vch)
            setIsSending(false)
            utils.showSuccess(t('saved', {key: res.data.data.email}))
            history.push('confirmemail?email='+res.data.data["email"])
        } catch (error) {
            setIsSending(false)
            utils.showError(error)
        }
    }

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('create_email')}</div>
            <div className="Spacing-V-16"></div>
            <form onKeyDown={handleHotkey}>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('email')} labelFor="inputEmail">
                        <InputGroup id="inputEmail" name="email" inputRef={register} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('user_name')} labelFor="inputUserName">
                        <InputGroup id="inputUserName" name="name" inputRef={register} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('password')} labelFor="inputPassword">
                        <InputGroup id="inputPassword" name="password" type="password" inputRef={register} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('confirm')} labelFor="inputConfirm">
                        <InputGroup id="inputConfirm" name="confirm" type="password" inputRef={register} />
                    </FormGroup>
                </div>
                <div className="Spacing-V-16" />
                <div className="Row">
                    <Button className="Col-1-1" icon="add" disabled={isSending} onClick={handleSubmit(onSubmit)}>{t('create')}</Button>
                </div>
            </form>
        </>
    );
}

export default CreateEmail